export default __webpack_public_path__ + "static/media/fondo-susa-sinfondo.df5b3db5.png";